import { render, staticRenderFns } from "./PainelEscalaRoteiro.vue?vue&type=template&id=1f9c54f2&scoped=true"
import script from "./PainelEscalaRoteiro.vue?vue&type=script&lang=js"
export * from "./PainelEscalaRoteiro.vue?vue&type=script&lang=js"
import style0 from "./PainelEscalaRoteiro.vue?vue&type=style&index=0&id=1f9c54f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c54f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAutocomplete,VBtn,VCard,VChip,VCol,VIcon,VRow,VSelect,VSimpleTable})
